import { MDBAlert, MDBBtn, MDBBtnGroup, MDBDatatable, MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle, MDBIcon, MDBInput, MDBSpinner } from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getSMSGroups } from "../../apiclients/streamsapi_bridge";
import PopupLoader from "../../views/popups/PopupLoader";
import AddSMSGroups from "../../views/popups/users/AddSMSGroups";
import DeleteSMSGroup from "../../views/popups/users/DeleteSMSGroup";
import { Tooltip } from "react-tooltip";
import PopupLoaderNew from "../../views/popups/PopupLoaderNew";
import Body from "../body/BodyPage";
import MainLinks from "../navlinks/MainLinks";
import { formattedNumber } from "../../views/popups/phonenumbers/AddRemoveNumbers";
import  { customSearch, useAutoFocusSearchAfterLoads } from "../CustomSearchUtil/CustomSearch";
import UIConstant from "../../apiclients/UIConstant";
import TabIDConstant from "../../apiclients/TabIDConstant";
function SMSGroups() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [smsGroups, setsmsGroups] = useState([]);
    const [internalError, setInternalError] = useState(false);
    const [isloading, setIsloading] = useState(true);
    const [deleteGroup, setDeleteGroup] = useState(false);
    const dtogglePopup = () => setDeleteGroup(!deleteGroup);
    const [selectedGroupId, setSelectedGroupId] = useState();
    const addSMSGrpeRef = useRef(null);
    const [isLoading, setisLoading] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [filteredRows, setFilteredRows] = useState([]);
    const [smsGroupDetails, setSmsGroupDetails] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    function handleClick() {
        addSMSGrpeRef.current.click();
    }
useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef)

    async function fetchAllSMSGroups() {
        try {
            setInternalError(false);
            console.log(sessionStorage.getItem("admin_session"));
            const response = await getSMSGroups(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                TabIDConstant.SMS_GRPS_LINK
            );
            if (!response.json) {
                const message = `An error has occured: ${response.statusText}`;
                return;
            }
            const rawData = await response.json();
            if (!rawData) {
                setInternalError(true);
            }
            console.log("SMS Group data :::::::::: " + JSON.stringify(rawData));
            setsmsGroups(rawData?.smsgroups ?? []);
            setTimeout(() => {
                setIsloading(false);
            }, 1000);
              setDataLoaded(true);
        } catch (error) {

        }
    }

    useEffect(() => {
        fetchAllSMSGroups();

    }, [])

    function deletethisGroup(evntData, groupId) {
        evntData.preventDefault();
        evntData.stopPropagation();
        setSelectedGroupId(groupId)
        setDeleteGroup(true)
    }

    useEffect(()=>{
    let processdrows = [];
    smsGroups.map((group) => {
        let phNumber = group.primary_number ? formattedNumber(group.primary_number) + "" : ""
        processdrows.push({
            groupInfo: group,
            name: group.name + "",
            mailid: group.mailid + "",
            actualNumber : phNumber?.toString().replace(/[ ]/g, ''),
            primary_number : phNumber,
            number: group.primary_number + "" ?? "",
            location: group.location_name + "",
            remove: (
                <>
                    {/* <div className="ms-4">
                        <MDBIcon fas icon="times" color="primary" title="Remove"
                            onClick={(e) => deletethisGroup(e, group.code)}
                        />
                    </div> */}

                    <div className="d-flex align-items-center justify-content-center">
                        <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => deletethisGroup(e, group.code)}>
                            <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
                        </div>
                    </div>

                </>
            ),

        })
    });
    setFilteredRows(processdrows)
    setSmsGroupDetails(processdrows);
},[smsGroups])
    const actionData = {
        columns: [
            { label: 'Group Name', field: 'name' },
            // { label: 'Group Mail ID', field: 'mailid' },
            { label: 'Primary Number', field: 'primary_number'},
            { label: 'Location', field: 'location' },
            { label: 'Remove', field: 'remove', sort: false },
        ],
        rows: smsGroupDetails,

    }

    const handleManualSearch = (searchValue) => {
        setSearchValue(searchValue);
        const filtered = customSearch(smsGroupDetails, searchValue, UIConstant.SMS_GROUPS);

        setFilteredRows(filtered);
    };


    function showThisInf(tdata) {
        navigate("/smsgroupseditmain", {
            state: tdata.groupInfo,
        })
    }

    const [addSMSGroups, setAddSMSGroups] = useState(false);
    const toggleOpen = () => setAddSMSGroups(!addSMSGroups);
    return (
        <React.Fragment>
            <>
                <MainLinks active={2} />
                <Body
                    tablinks={2}
                    sublink={283}
                    content={

                        <section className="mb-3">
                            <div className="card card-height">
                                <div className="card-header py-3 px-0">
                                    <h5 className="mb-0 ">
                                        {t("smsgroups")}
                                    </h5>
                                </div>

                                <>
                                    <div className="mt-3">
                                        <div className="faxGroupsDataTable">
                                            <div className="actionbar button_aligniment ">

                                                <div className="float-end d-flex align-items-center mt-2_responsive">
                                                    <MDBBtn className="btn_adjust" onClick={toggleOpen}  >
                                                        <MDBIcon fas icon="plus" className="me-2" /> {t("addnewsmsgroup")}
                                                    </MDBBtn>

                                                </div>
                                            </div>
                                            <div className="smsgroups-datatable mt-3 actioncolumn">
                                                
                                                <div className="actionbar"></div>
                                                 <div className='mb-2 mt-0 position-relative w-auto'>
                                                    <MDBInput
                                                        label="Search"
                                                        ref={searchRef}
                                                        value={searchValue}
                                                        onChange={(e) => handleManualSearch(e.target.value)}
                                                    />
                                                    <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                                                </div>
                                                <MDBDatatable
                                                    key={searchValue}
                                                    // search
                                                    entries={50}
                                                    sortField="Group Name"
                                                    hover
                                                    data={{...actionData,
                                                        rows:filteredRows}
                                                    }
                                                    onRowClick={(event) => {
                                                        showThisInf(event);
                                                    }}
                                                />
                                            </div>


                                            {addSMSGroups && (
                                                <PopupLoaderNew
                                                    title="Add SMS Group"
                                                    content={
                                                        <AddSMSGroups
                                                            onClose={toggleOpen}
                                                            ref={addSMSGrpeRef}
                                                            setIsloading={setisLoading}
                                                        />
                                                    }
                                                    onShow={setAddSMSGroups}
                                                    onClose={toggleOpen}
                                                    onSave={handleClick}
                                                    isloading={isLoading}
                                                    flag={1}

                                                />
                                            )}

                                            {internalError && (
                                                <MDBAlert
                                                    open
                                                    className="alert-center"
                                                    color="danger"
                                                    autohide
                                                    position="bottom-right"
                                                    delay={5000}
                                                    onClose={() => setInternalError(false)}
                                                >
                                                    Internal Server Error
                                                </MDBAlert>
                                            )}

                                            {deleteGroup && (
                                                <PopupLoaderNew
                                                    title={"Remove SMS Group"}
                                                    content={<DeleteSMSGroup
                                                        groupId={selectedGroupId}
                                                        onClose={dtogglePopup}
                                                        ref={addSMSGrpeRef}
                                                        setIsloading={setisLoading}
                                                    />}
                                                    onShow={setDeleteGroup}
                                                    onClose={dtogglePopup}
                                                    onSave={handleClick}
                                                    isloading={isLoading}
                                                    flag={4}
                                                />
                                            )}

                                            {isloading && (
                                                <>
                                                    <div className="loadingclass">
                                                        <MDBBtn disabled>
                                                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                                            Loading...
                                                        </MDBBtn>
                                                    </div>
                                                </>
                                            )}

                                        </div>

                                    </div>
                                </>
                            </div>
                        </section>

                    }
                />

                <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                    Remove
                </Tooltip>
            </>
        </React.Fragment >

    )
}
export default SMSGroups